import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL, getRedirectKey, PUBLISHER_URL } from '../Utlils';
import CryptoJS from 'crypto-js';
import jsSHA from 'jssha';
import ResponseRecordedErrorPage from './ResponseRecordedErrorPage';
import surveyCompleted from '../assets/surveyComplete.svg';
import surveyInterrupted from '../assets/surveyInterrupted.svg';
import maxResponse from '../assets/maxResponse.svg';
import terminated from '../assets/terminated.svg';
import TooManyRequest from '../assets/TooManyRequest.svg';
import Hashids from 'hashids';
import { getSupplierRedirect } from '../Actions/commonActions';

function msToTime(milliseconds) {
  // Convert milliseconds to seconds
  let seconds = Math.floor(milliseconds / 1000);

  // Calculate hours, minutes, and remaining seconds
  const hours = Math.floor(seconds / 3600);
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);
  seconds %= 60;

  // Format into "hh:mm:ss"
  const formattedTime = `${String(hours).padStart(2, '0')}:${String(
    minutes,
  ).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

  return formattedTime;
}
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}
function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
const EndPoint = () => {
  const [errorPage, setErrorPage] = useState(false);
  const urlSearchParams = new URLSearchParams(window.location.search);
  const { id, s, h, respondentId } = Object.fromEntries(
    urlSearchParams.entries(),
  );
  // console.log(
  //   " Object.fromEntries(urlSearchParams.entries())=>",
  //   Object.fromEntries(urlSearchParams.entries())
  // );

  let newId = id || respondentId;

  const hashids = new Hashids('My Project');
  const decodedID = hashids.decode(
    newId?.includes('-') ? newId?.split('-')[1] : newId,
  );

  const status = Number(s);
  const renderEndScreen = () => {
    const status = Number(s);
    // console.log("status=>", status);

    switch (true) {
      case status === 10:
        return (
          <>
            <div className="flex justify-center items-center ml-[150px] tablet: tablet:flex-col-reverse tablet:mx-[88px] ipad:mx-6">
              <section className="tablet:mt-[80px] ipad:mt-[30px]">
                <h1 className="text-[32px] font-[700] mb-7 ipad:text-[24px]">
                  You’ve successfully completed the survey.
                </h1>
                <p className="text-[19px] text-[#646464] leading-relaxed ipad:text-[16px]">
                  Congratulations! You’ve successfully completed the survey,
                  your rewards will be credited in your panel account. Thank you
                  very much ;)
                </p>
                <button className="mt-[62px] bg-primary hover:bg-[#1e64fb] px-4 py-3 text-white font-semibold rounded w-[151px] text-[14px]">
                  Contact support
                </button>
              </section>
              <img
                src={surveyCompleted}
                className="tablet:w-[304px] tablet:h-[230px]"
                alt="status illustration"
              />
            </div>
            <footer className="p-[17px_16px_17px_16px] mt-5 flex items-center justify-between bg-[#F3F3F3] w-[100%] text-[#333] absolute bottom-0">
              <p className="text-[13px] ipad:text-[6px]">
                ©2023 Mirats Quanto Private Limited.
              </p>
              <ul className="text-[12px] ipad:text-[6px] list-none font-[300] flex items-center gap-[32px] ipad:gap-1">
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/privacy-policy">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/gdpr">
                    GDPR Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/ccpa">
                    CCPA Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/terms-of-service">
                    Terms of Use
                  </a>
                </li>
              </ul>
            </footer>
          </>
        );
      case status >= 20 && status <= 29:
        return (
          <>
            <div className="flex justify-center items-center ml-[150px] tablet: tablet:flex-col-reverse tablet:mx-[88px] ipad:mx-6">
              <section className="tablet:mt-[80px] ipad:mt-[30px]">
                <h1 className="text-[32px] font-[700] mb-7 ipad:text-[24px]">
                  You’re terminated
                </h1>
                <p className="text-[19px] text-[#646464] leading-relaxed ipad:text-[16px]">
                  Unfortunately, you’re not able to qualify the survey, we
                  appreciate your willingness to take the survey. Thank you very
                  much for your precious time.
                </p>
                <button className="mt-[62px] bg-primary hover:bg-[#1e64fb] px-4 py-3 text-white font-semibold rounded w-[151px] text-[14px]">
                  Contact support
                </button>
              </section>
              <img
                src={terminated}
                className="tablet:w-[304px] tablet:h-[230px]"
                alt="status illustration"
              />
            </div>
            <footer className="p-[17px_16px_17px_16px] mt-5 flex items-center justify-between bg-[#F3F3F3] w-[100%] text-[#333] absolute bottom-0">
              <p className="text-[13px] ipad:text-[6px]">
                ©2023 Mirats Quanto Private Limited.
              </p>
              <ul className="text-[12px] ipad:text-[6px] list-none font-[300] flex items-center gap-[32px] ipad:gap-1">
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/privacy-policy">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/gdpr">
                    GDPR Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/ccpa">
                    CCPA Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/terms-of-service">
                    Terms of Use
                  </a>
                </li>
              </ul>
            </footer>
          </>
        );
      case status >= 40 && status <= 49:
        return (
          <>
            <div className="flex justify-center items-center ml-[150px] tablet: tablet:flex-col-reverse tablet:mx-[88px] ipad:mx-6">
              <section className="tablet:mt-[80px] ipad:mt-[30px]">
                <h1 className="text-[32px] font-[700] mb-7 ipad:text-[24px]">
                  We received maximum responses.
                </h1>
                <p className="text-[19px] text-[#646464] leading-relaxed ipad:text-[16px]">
                  Unfortunately, we are not able to let you proceed with this
                  survey as we’ve already reached maximum number of completes.
                  Thank you very much for your participation.
                </p>
                <button
                  //   onClick={() => setIndex(index + 1)}
                  className="mt-[62px] bg-primary hover:bg-[#1e64fb] px-4 py-3 text-white font-semibold rounded w-[151px] text-[14px]"
                >
                  Contact support
                </button>
              </section>
              <img
                src={maxResponse}
                className="tablet:w-[304px] tablet:h-[230px]"
                alt="status illustration"
              />
            </div>
            <footer className="p-[17px_16px_17px_16px] mt-5 flex items-center justify-between bg-[#F3F3F3] w-[100%] text-[#333] absolute bottom-0">
              <p className="text-[13px] ipad:text-[6px]">
                ©2023 Mirats Quanto Private Limited.
              </p>
              <ul className="text-[12px] ipad:text-[6px] list-none font-[300] flex items-center gap-[32px] ipad:gap-1">
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/privacy-policy">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/gdpr">
                    GDPR Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/ccpa">
                    CCPA Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/terms-of-service">
                    Terms of Use
                  </a>
                </li>
              </ul>
            </footer>
          </>
        );
      case status >= 30 && status <= 39:
        return (
          <>
            <div className="flex justify-center items-center ml-[150px] tablet: tablet:flex-col-reverse tablet:mx-[88px] ipad:mx-6">
              <section className="tablet:mt-[80px] ipad:mt-[30px]">
                <h1 className="text-[32px] font-[700] mb-7 ipad:text-[24px]">
                  We detected something unusual.
                </h1>
                <p className="text-[19px] text-[#646464] leading-relaxed ipad:text-[16px]">
                  Unfortunately, we won’t let you proceed here as our system
                  detected some unusual activity on our survey pages.
                </p>
                <button className="mt-[62px] bg-primary hover:bg-[#1e64fb] px-4 py-3 text-white font-semibold rounded w-[151px] text-[14px]">
                  Contact support
                </button>
              </section>
              <img
                src={surveyInterrupted}
                className="tablet:w-[304px] tablet:h-[230px]"
                alt="status illustration"
              />
            </div>
            <footer className="p-[17px_16px_17px_16px] mt-5 flex items-center justify-between bg-[#F3F3F3] w-[100%] text-[#333] absolute bottom-0">
              <p className="text-[13px] ipad:text-[6px]">
                ©2023 Mirats Quanto Private Limited.
              </p>
              <ul className="text-[12px] ipad:text-[6px] list-none font-[300] flex items-center gap-[32px] ipad:gap-1">
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/privacy-policy">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/gdpr">
                    GDPR Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/ccpa">
                    CCPA Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/terms-of-service">
                    Terms of Use
                  </a>
                </li>
              </ul>
            </footer>
          </>
        );
      // case '33':
      //   return (
      //     <div className="flex items-center justify-center flex-col">
      //       <div className="flex justify-center items-center  tablet:ml-0 tablet:flex-col-reverse tablet:px-[10px]  w-[80%] ipad:w-full ">
      //         <section className="tablet:mt-[40px] ipad:mt-[30px] ">
      //           <h1 className="text-[32px] font-[700] mb-7 tablet:mb-4 ipad:text-[24px]">
      //             Survey not available
      //           </h1>
      //           <p className="text-[19px] text-[#646464] leading-relaxed ipad:text-[16px]">
      //             The survey you are trying to access is not available at this
      //             time. Please contact support for more information.
      //           </p>
      //           <Link to="mailto:diysupport@miratsinsights.com">
      //             <button className="mt-[62px] bg-primary hover:bg-[#1e64fb] px-4 py-3 text-white font-semibold rounded w-[151px] text-[14px]">
      //               Contact support
      //             </button>
      //           </Link>
      //         </section>
      //         <img
      //           src={NotAvailable}
      //           className="tablet:w-[254px] tablet:h-[200px] "
      //           alt="status illustration"
      //         />
      //       </div>
      //       <footer className="p-[17px_16px_17px_16px] mt-5 flex items-center justify-between bg-[#F3F3F3] w-[100%] text-[#333] absolute bottom-0">
      //         <p className="text-[13px] ipad:text-[6px]">
      //           ©{new Date().getFullYear()} Mirats Quanto Private Limited.
      //         </p>
      //         <ul className="text-[12px] ipad:text-[6px] list-none font-[300] flex items-center gap-[32px] ipad:gap-1">
      //           <li>
      //             <a href="https://consumerinsights.miratsoneservices.com/privacy-policy">
      //               Privacy Policy
      //             </a>
      //           </li>
      //           <li>
      //             <a href="https://consumerinsights.miratsoneservices.com/gdpr">
      //               GDPR Policy
      //             </a>
      //           </li>
      //           <li>
      //             <a href="https://consumerinsights.miratsoneservices.com/ccpa">
      //               CCPA Policy
      //             </a>
      //           </li>
      //           <li>
      //             <a href="https://consumerinsights.miratsoneservices.com/terms-of-service">
      //               Terms of Use
      //             </a>
      //           </li>
      //         </ul>
      //       </footer>
      //     </div>
      //   );
      case status === 429:
        return (
          <>
            <div className="flex justify-center items-center ml-[150px] tablet: tablet:flex-col-reverse tablet:mx-[88px] ipad:mx-6 gap-[40px] ">
              <section className="tablet:mt-[80px] ipad:mt-[30px] ">
                <h1 className="text-[32px] font-[700] mb-7 ipad:text-[24px]">
                  Oops, we hit a snag!
                </h1>
                <p className="text-[19px] text-[#646464] leading-relaxed ipad:text-[16px]">
                  We're really sorry, but it seems like we have an unusually
                  high number of users accessing our website right now.
                  Unfortunately, we've reached our maximum number of sessions
                  limit.
                </p>
                <p className="text-[16px] font-[600] text-[#292929] leading-relaxed ipad:text-[16px] mt-4">
                  Why am I seeing this?
                </p>
                <p className="text-[19px] text-[#646464] leading-relaxed ipad:text-[16px] ">
                  Our website can only handle a certain number of users at once
                  to ensure everyone gets the smoothest and fastest experience
                  possible. It looks like we've hit that limit, but don't worry
                  - spaces open up fast!
                </p>
                <p className="text-[16px] font-[600] text-[#292929] leading-relaxed ipad:text-[16px] mt-4">
                  What can I do?
                </p>
                <p className="text-[19px] text-[#646464] leading-relaxed ipad:text-[16px] ">
                  Please wait for a few minutes before trying again. We'll be
                  ready to welcome you back as soon as some space frees up!
                </p>
                {/* <button className="mt-[62px] bg-primary hover:bg-[#1e64fb] px-4 py-3 text-white font-semibold rounded w-[151px] text-[14px]">
                      Contact support
                    </button> */}
              </section>
              <img
                src={TooManyRequest}
                className="tablet:w-[304px] tablet:h-[130px] w-[450px] ipad:w-[200px] tablet:mt-[50px] "
                alt="status illustration"
              />
            </div>
            <footer className="p-[17px_16px_17px_16px] mt-5 flex items-center justify-between bg-[#F3F3F3] w-[100%] text-[#333] absolute bottom-0">
              <p className="text-[13px] ipad:text-[6px]">
                ©2023 Mirats Quanto Private Limited.
              </p>
              <ul className="text-[12px] ipad:text-[6px] list-none font-[300] flex items-center gap-[32px] ipad:gap-1">
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/privacy-policy">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/gdpr">
                    GDPR Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/ccpa">
                    CCPA Policy
                  </a>
                </li>
                <li>
                  <a href="https://consumerinsights.miratsoneservices.com/terms-of-service">
                    Terms of Use
                  </a>
                </li>
              </ul>
            </footer>
          </>
        );
      default:
        return (
          <div className="w-full h-screen flex items-center justify-center">
            <h1>Something Went Wrong</h1>
          </div>
        );
    }
  };

  // useEffect(() => {
  //   if (!newId) {
  //     return;
  //   }

  //   let gamma = localStorage.getItem('gamma'); // gamma = alpha means test session

  //   let order_id;
  //   let response = getCookie(`response-${newId}`);

  //   if (!response) {
  //     console.log('inside if');
  //     axios
  //       .get(`${BASE_URL}/session/get-session-ref?refID=${newId}`)
  //       .then((data) => {
  //         setCookie(`response-${newId}`, true, 10);

  //         let sessions = data.data;

  //         const sd = data.data;
  //         // console.log(data.data);
  //         let survey_end_time = new Date();
  //         const total_survey_time = msToTime(
  //           new Date().getTime() - new Date(sd?.survey_start_time).getTime(),
  //         );

  //         // console.log(total_survey_time);
  //         let body = {
  //           survey_end_time,
  //           total_survey_time,
  //           // client_status: parseInt(status),
  //           client_status: [30, 31, 33, 35, 36, 37, 38, 23, 40]?.includes(
  //             parseInt(sd?.mirats_status),
  //           )
  //             ? -1
  //             : parseInt(s),

  //           is_reconciled: false,
  //         };
  //         let surveyNumber;
  //         axios.get(`${BASE_URL}/survey/one?id=${sd?.survey}`).then((sdata) => {
  //           let res = sdata.data;
  //           order_id = res?.order_id;
  //           surveyNumber = res?.surveyNumber;
  //           // if (
  //           //   parseInt(s) === 10 &&
  //           //   parseInt(total_survey_time.split(':')[1]) <= res?.speeder_loi
  //           // ) {
  //           //   body.client_status = 12;
  //           // }
  //           axios
  //             .put(`${BASE_URL}/session?id=${sessions._id}`, body)
  //             .then(async (data) => {
  //               if (data.data == false) {
  //                 setErrorPage(true);
  //               } else {
  //                 const isMiratsAllocation = res?.allocation?.some(
  //                   (item) => item?.supplierAccount == supplierAccountId,
  //                 );

  //                 if (!isMiratsAllocation) {
  //                   // redirecting based on supplier allocation
  //                   const supplierRedirectData = await getSupplierRedirect({
  //                     sessionId: sessions._id,
  //                   });
  //                   const url = supplierRedirectData?.data?.redirectURL;
  //                   if (supplierRedirectData?.success && url) {
  //                     window.location.href = url;
  //                     return;
  //                   }
  //                 }
  //               }
  //             })
  //             .catch((err) => console.log(err.message));
  //         });
  //         // console.log("=>", sessions?.publisherProjectId);
  //         if (sessions?.publisherProjectId) {
  //           axios
  //             .get(`${PUBLISHER_URL}/project/${sessions?.publisherProjectId}`)
  //             .then((response) => {
  //               const pubData = response?.data?.data;
  //               // console.log("PubData=>", pubData);
  //               axios
  //                 .put(
  //                   `${PUBLISHER_URL}/session/update-by-ref/${sessions?.publisherProjectId}/${sessions?.rid}`,
  //                   {
  //                     startTime: sessions?.survey_start_time,
  //                     endTime: survey_end_time,
  //                     totalTime: total_survey_time,
  //                     status: s,
  //                   },
  //                 )
  //                 .then((updPubSess) => {
  //                   const buildCallbackUrl = (callbackUrl) => {
  //                     let url = callbackUrl
  //                       ?.replace('[%rid%]', sd.rid)
  //                       ?.replace('[%pub_refid%]', sd.rid)
  //                       ?.replace('[%survey_id%]', surveyNumber || sd.rid);

  //                     url = new URL(url);

  //                     let params = new URLSearchParams(url.search);

  //                     if (params.has('source_id') && sd?.source_id) {
  //                       params.set('source_id', sd.source_id);
  //                     }

  //                     if (params.has('utm_id') && sd?.utm_id) {
  //                       params.set('utm_id', sd.utm_id);
  //                     }

  //                     url.search = params.toString();

  //                     return url;
  //                   };
  //                   const replaceData = {
  //                     '[%rid%]': sessions?.rid || 'defaultRid',
  //                     '[%pub_refid%]': sessions?.rid || 'defaultPubRefId',
  //                     '[%survey_id%]':
  //                       surveyNumber || sessions?.rid || 'defaultSurveyId',
  //                     '[%surveyNumber%]':
  //                       surveyNumber || sessions?.rid || 'defaultSurveyId',
  //                   };
  //                   const redirectKey = getRedirectKey(s);
  //                   const redirectUrl = pubData?.redirects?.[redirectKey];

  //                   if (Object.keys(pubData?.callbackURLs || {})?.length) {
  //                     let modifiedURL;
  //                     const callbackUrl =
  //                       s == 10
  //                         ? pubData?.callbackURLs?.success
  //                         : pubData?.callbackURLs?.failure;
  //                     if (callbackUrl) {
  //                       modifiedURL = buildCallbackUrl(callbackUrl);
  //                     }
  //                     if (modifiedURL) {
  //                       const requestMethod =
  //                         pubData?.callbackURLs?.requestType?.label || 'GET';
  //                       if (requestMethod === 'POST') {
  //                         axios
  //                           .post(modifiedURL.toString())
  //                           .then(() => {
  //                             console.log(
  //                               'POST Publisher callback URL called successfully!',
  //                             );
  //                           })
  //                           .catch(() => {
  //                             console.log(
  //                               'Error calling POST publisher callback URL',
  //                             );
  //                           });
  //                       } else {
  //                         axios
  //                           .get(modifiedURL.toString())
  //                           .then(() => {
  //                             console.log(
  //                               'GET Publisher callback URL called successfully!',
  //                             );
  //                           })
  //                           .catch(() => {
  //                             console.log(
  //                               'Error calling GET publisher callback URL',
  //                             );
  //                           });
  //                       }
  //                     }
  //                   } else {
  //                     console.log(
  //                       "Callback URL(server side url) not set in publisher's project.",
  //                     );
  //                   }
  //                   if (redirectUrl) {
  //                     let modifiedUrl = redirectUrl;

  //                     modifiedUrl = modifiedUrl.replace(
  //                       /\[%[a-zA-Z_]+\%\]/g,
  //                       (match) => {
  //                         return replaceData[match] || match;
  //                       },
  //                     );
  //                     let url = new URL(modifiedUrl);
  //                     let myUrlParams = new URLSearchParams(url.search);
  //                     if (myUrlParams.has('source_id') && sd?.source_id) {
  //                       myUrlParams.set('source_id', sd.source_id);
  //                     }
  //                     if (myUrlParams.has('utm_id') && sd?.utm_id) {
  //                       myUrlParams.set('utm_id', sd.utm_id);
  //                     }
  //                     url.search = myUrlParams.toString();
  //                     const newURL = url.toString();
  //                     if (
  //                       sd?.publisherOrganizationId ==
  //                       process.env.REACT_APP_THEOREM_REACH_ID
  //                     ) {
  //                       axios
  //                         .post(
  //                           `${BASE_URL}/redirect/get-theorem-reach-redirect`,
  //                           { baseUrl: newURL },
  //                         )
  //                         .then((res) => {
  //                           let redirectData = res.data;
  //                           let hashedURL = redirectData?.signedUrl;
  //                           console.log(
  //                             `Redirecting theorem publisher to hash URL ${hashedURL}`,
  //                           );
  //                           window.location.href = hashedURL;
  //                           return;
  //                         })
  //                         .catch((er) => {
  //                           console.log(
  //                             'Error in hashing theorem publisher redirects',
  //                           );
  //                         });
  //                     } else if (
  //                       sd?.publisherOrganizationId ==
  //                       process.env.REACT_APP_Tcsurvey_ID
  //                     ) {
  //                       axios
  //                         .post(`${BASE_URL}/redirect/get-Tcsurvey-redirect`, {
  //                           baseUrl: newURL,
  //                         })
  //                         .then((res) => {
  //                           let redirectData = res.data;
  //                           let hashedURL = redirectData?.signedUrl;
  //                           console.log(
  //                             `Redirecting Tcsurvey publisher to hash URL ${hashedURL}`,
  //                           );
  //                           window.location.href = hashedURL;
  //                           return;
  //                         })
  //                         .catch((er) => {
  //                           console.log('Error in hashing publisher redirects');
  //                         });
  //                     } else {
  //                       console.log('URL=>', newURL);
  //                       window.location.href = newURL;
  //                     }
  //                   } else {
  //                     console.log(
  //                       `Publisher's ${redirectKey} redirect not set or invalid.`,
  //                     );
  //                   }
  //                 })
  //                 .catch((er) => {
  //                   console.log(er);
  //                   console.log('unable to update publisher data');
  //                 });
  //             })
  //             .catch((er) => console.log('error in getting publisher data'));
  //         } else {
  //           console.log('no redirects');
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err.message);
  //       });
  //   } else {
  //     console.log('insdie else');
  //     setErrorPage(true);
  //   }
  // }, [decodedID]);

  // updated useEffect 19 Oct 2026
  useEffect(() => {
    if (!newId) return;

    const responseCookieKey = `response-${newId}`;

    // Already processed in this browser: don't process twice.
    if (getCookie(responseCookieKey)) {
      setErrorPage(true);
      return;
    }

    // Only used BEFORE the cookie is set. Once processing has started
    // (cookie written), the flow always runs to completion so the
    // callback / redirect can never be skipped half-way.
    let cancelled = false;

    const REQUEST_TIMEOUT = 10000;
    const CALLBACK_TIMEOUT = 5000;
    const requestConfig = { timeout: REQUEST_TIMEOUT };

    const processResponse = async () => {
      try {
        // 1. Fetch the current session
        const { data: sd } = await axios.get(
          `${BASE_URL}/session/get-session-ref?refID=${newId}`,
          requestConfig,
        );

        if (cancelled) return;

        if (!sd?._id) {
          throw new Error('Session not found');
        }

        // Prevent duplicate processing
        setCookie(responseCookieKey, true, 10);

        const surveyEndTime = new Date();
        const totalSurveyTime = msToTime(
          surveyEndTime.getTime() - new Date(sd.survey_start_time).getTime(),
        );

        const parsedStatus = Number.parseInt(String(status), 10);
        const miratsStatus = Number.parseInt(String(sd.mirats_status), 10);

        const statusesToTerminate = new Set([
          30, 31, 33, 35, 36, 37, 38, 23, 40,
        ]);

        const sessionBody = {
          survey_end_time: surveyEndTime,
          total_survey_time: totalSurveyTime,
          client_status: statusesToTerminate.has(miratsStatus)
            ? -1
            : parsedStatus,
          is_reconciled: false,
        };

        const hasPublisherProject = Boolean(sd.publisherProjectId);

        const [surveyResult, sessionResult, projectResult, publisherPutResult] =
          await Promise.allSettled([
            axios.get(`${BASE_URL}/survey/one?id=${sd.survey}`, requestConfig),
            axios.put(
              `${BASE_URL}/session?id=${sd._id}`,
              sessionBody,
              requestConfig,
            ),
            hasPublisherProject
              ? axios.get(
                  `${PUBLISHER_URL}/project/${sd.publisherProjectId}`,
                  requestConfig,
                )
              : Promise.resolve(null),
            hasPublisherProject
              ? axios.put(
                  `${PUBLISHER_URL}/session/update-by-ref/${sd.publisherProjectId}/${sd.rid}`,
                  {
                    startTime: sd.survey_start_time,
                    endTime: surveyEndTime,
                    totalTime: totalSurveyTime,
                    status,
                  },
                  requestConfig,
                )
              : Promise.resolve(null),
          ]);

        // 2a. Session finalize: `false` from the API means the session is invalid.
        if (sessionResult.status === 'rejected') {
          console.error(
            'Unable to finalize session:',
            sessionResult.reason?.message,
          );
        } else if (sessionResult.value?.data === false) {
          setErrorPage(true);
          return;
        }

        // 2b. Survey details (needed for surveyNumber + allocation).
        let survey = null;
        if (surveyResult.status === 'fulfilled') {
          survey = surveyResult.value?.data || null;
        } else {
          console.error(
            'Unable to fetch survey:',
            surveyResult.reason?.message,
          );
        }
        const surveyNumber = survey?.surveyNumber;

        // 2c. Publisher project + publisher session update.
        let pubData = null;
        if (projectResult.status === 'fulfilled') {
          pubData = projectResult.value?.data?.data || null;
        } else if (hasPublisherProject) {
          console.error(
            'Unable to fetch publisher project:',
            projectResult.reason?.message,
          );
        }
        if (publisherPutResult.status === 'rejected') {
          console.error(
            'Unable to update publisher session:',
            publisherPutResult.reason?.message,
          );
        }

        // If survey couldn't be loaded we can't know the allocation,
        // so skip the supplier redirect and fall through to the publisher one.
        const isMiratsAllocation = survey
          ? Boolean(
              survey.allocation?.some(
                (allocation) =>
                  allocation?.supplierAccount == sd.supplierAccountId,
              ),
            )
          : true;

        // 3. URL helpers
        const replacementData = {
          '[%rid%]': sd.rid || 'defaultRid',
          '[%pub_refid%]': sd.rid || 'defaultPubRefId',
          '[%survey_id%]': surveyNumber || sd.rid || 'defaultSurveyId',
          '[%surveyNumber%]': surveyNumber || sd.rid || 'defaultSurveyId',
        };

        const buildUrl = (template) => {
          if (typeof template !== 'string' || !template.trim()) return null;

          const resolvedTemplate = template.replace(
            /\[%[a-zA-Z_]+%]/g,
            (placeholder) =>
              Object.prototype.hasOwnProperty.call(replacementData, placeholder)
                ? encodeURIComponent(String(replacementData[placeholder]))
                : placeholder,
          );

          const url = new URL(resolvedTemplate);
          const params = new URLSearchParams(url.search);

          if (params.has('source_id') && sd.source_id != null) {
            params.set('source_id', sd.source_id);
          }
          if (params.has('utm_id') && sd.utm_id != null) {
            params.set('utm_id', sd.utm_id);
          }

          url.search = params.toString();
          return url;
        };

        // 4. Publisher server-side callback (never throws)
        const sendPublisherCallback = async () => {
          if (!pubData) return;

          const callbackURLs = pubData.callbackURLs || {};
          if (!Object.keys(callbackURLs).length) {
            console.log("Callback URL not set in publisher's project.");
            return;
          }

          const callbackTemplate =
            parsedStatus === 10 ? callbackURLs.success : callbackURLs.failure;
          if (!callbackTemplate) return;

          try {
            const callbackUrl = buildUrl(callbackTemplate);
            if (!callbackUrl) return;

            const method = String(
              callbackURLs.requestType?.label || 'GET',
            ).toUpperCase();
            const config = { timeout: CALLBACK_TIMEOUT };

            if (method === 'POST') {
              await axios.post(callbackUrl.toString(), undefined, config);
            } else {
              await axios.get(callbackUrl.toString(), config);
            }
            console.log(`${method} publisher callback called successfully!`);
          } catch (error) {
            console.error('Error calling publisher callback:', error?.message);
          }
        };

        // 5. Supplier redirect, only when supplier is not in Mirats allocation (never throws)
        const getSupplierRedirectUrl = async () => {
          if (isMiratsAllocation || hasPublisherProject) return null;

          try {
            const supplierRedirectData = await getSupplierRedirect({
              sessionId: sd._id,
            });
            const supplierRedirectURL = supplierRedirectData?.data?.redirectURL;

            if (supplierRedirectData?.success && supplierRedirectURL) {
              return supplierRedirectURL;
            }
            console.warn(
              'Supplier redirect URL was not available; checking publisher redirects.',
            );
          } catch (error) {
            console.error('Error getting supplier redirect:', error?.message);
          }
          return null;
        };

        // The callback and the supplier lookup are independent: run together,
        // and wait for the callback before leaving the page.
        const [, supplierRedirectURL] = await Promise.all([
          sendPublisherCallback(),
          getSupplierRedirectUrl(),
        ]);

        if (supplierRedirectURL) {
          window.location.href = supplierRedirectURL;
          return;
        }

        // 6. Fall back to the publisher project redirect
        if (!hasPublisherProject) {
          console.log('No publisher project configured for redirects.');
          return;
        }

        if (!pubData) {
          console.log(
            'Publisher project data unavailable; cannot build publisher redirect.',
          );
          return;
        }

        const redirectKey = getRedirectKey(status);
        const redirectTemplate = pubData.redirects?.[redirectKey];

        if (!redirectTemplate) {
          console.log(`Publisher's ${redirectKey} redirect is not configured.`);
          return;
        }

        const redirectUrl = buildUrl(redirectTemplate);

        if (!redirectUrl) {
          console.log('Unable to build publisher redirect URL.');
          return;
        }

        const newURL = redirectUrl.toString();

        // 7. Publishers that need a signed redirect URL
        const publisherOrgId = String(sd.publisherOrganizationId ?? '');

        const signedPublisher = [
          {
            name: 'Theorem Reach',
            orgId: process.env.REACT_APP_THEOREM_REACH_ID,
            endpoint: '/redirect/get-theorem-reach-redirect',
          },
          {
            name: 'Tcsurvey',
            orgId: process.env.REACT_APP_Tcsurvey_ID,
            endpoint: '/redirect/get-Tcsurvey-redirect',
          },
        ].find(({ orgId }) => orgId && String(orgId) === publisherOrgId);

        if (signedPublisher) {
          try {
            const hashResponse = await axios.post(
              `${BASE_URL}${signedPublisher.endpoint}`,
              { baseUrl: newURL },
              requestConfig,
            );

            const signedUrl = hashResponse?.data?.signedUrl;

            if (!signedUrl) {
              console.error(
                `${signedPublisher.name} redirect did not return a signed URL.`,
              );
              return;
            }

            console.log(
              `Redirecting ${signedPublisher.name} publisher to signed URL ${signedUrl}`,
            );
            window.location.href = signedUrl;
          } catch (error) {
            console.error(
              `Error generating ${signedPublisher.name} redirect:`,
              error?.message,
            );
          }
          return;
        }

        // 8. Standard publisher redirect
        console.log('Redirect URL:', newURL);
        window.location.href = newURL;
      } catch (error) {
        console.error(
          'Error processing survey response:',
          error?.message || error,
        );
        if (!cancelled) setErrorPage(true);
      }
    };

    processResponse();

    return () => {
      cancelled = true;
    };
  }, [newId, status]);
  return (
    <>
      {!errorPage ? (
        <>
          <div className="w-full pt-5 h-[100dvh] bg-[#F6F5F4]">
            <img
              src="https://miratsinsights.com/logo.svg"
              alt="logo"
              className="w-[160px] mx-[150px] ipad:ml-6"
            />
            <div className="flex justify-center items-center h-[85%]">
              {renderEndScreen()}
            </div>
          </div>
        </>
      ) : (
        <ResponseRecordedErrorPage />
      )}
    </>
  );
};

export default EndPoint;
